export default __webpack_public_path__ + "static/media/mini@2x.961e3f91.svg";